import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import TextBlockConstants from '../../TextBlock.constants';
import styles from './TextBlockText.module.scss';
const { EMPTY_TEXT_CODE } = TextBlockConstants;
const TextBlockText = ({ item, isBlocked, isPlain, placeholder = '', }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && ref.current.textContent !== item.value) {
            ref.current.textContent = item.value
                ? item.value.replace(EMPTY_TEXT_CODE, '') + EMPTY_TEXT_CODE
                : EMPTY_TEXT_CODE;
        }
        else if (ref.current && !item.value) {
            ref.current.textContent = EMPTY_TEXT_CODE;
        }
    }, [item.value]);
    return (_jsx("span", { ref: ref, id: item.id, "placeholder-after-content": placeholder, contentEditable: !isBlocked && !isPlain, suppressContentEditableWarning: true, className: styles.text, "data-text": true }));
};
export default observer(TextBlockText);
